<template>
  <div>
    <div class="clinic-info" @click="selectClinic">
      <span class="name">{{ curClinicName }} <icon name="arrow" v-if="canChange"/></span>
      <!-- <span class="read-more" v-if="canChange"> <icon name="arrow"/></span> -->
    </div>

    <Popup v-model="visible" round @closed="visible = false">
      <div class="opinion-warp">
        <p class="opinion-title">选择药店</p>

        <div class="radio-warp">
          <radio-group v-model="clinicId">
            <radio :name="item.clinicId" v-for="(item, index) in clinicList" :key="index">
              {{ item.clinicName }}
            </radio>
          </radio-group>
        </div>

        <div class="btn" @click="submit">确认</div>
      </div>
    </Popup>
  </div>
</template>

<script>
import services from '@/service';
import { Icon, Popup, RadioGroup, Radio } from 'vant';
import { mapGetters } from 'vuex';
// import { getLocation } from '@/lib/utils';
// import { isMiniProgram } from '@/global';

export default {
  components: { Icon, Popup, RadioGroup, Radio },
  props: {
    initShow: {
      type: Boolean,
      default: false
    },
    immediate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pullLoading: false,
      scoreInfo: {
        todaySalseAmount: 0,
        cmSalseAmount: 0,
        lmSalseAmount: 0
      },
      searchVal: '',
      listInfo: [],
      stockList: [],
      clinicList: [],
      clinicId: null,
      clinicName: '',
      visible: false,
      latitude: '',
      longitude: ''
    };
  },
  async mounted() {
    await this.getBindClinics();
  },
  watch: {
    visible(val) {
      if (val) {
        this.$emit('open');
      } else {
        this.$emit('close');
      }
    }
  },
  computed: {
    ...mapGetters(['curClinicId', 'curClinicName']),
    canChange() {
      return this.clinicList.length > 1;
    }
  },
  methods: {
    selectClinic() {
      if (!this.canChange) return;
      this.visible = true;
    },
    async submit() {
      const selectedClinic = this.clinicList.find(item => item.clinicId === this.clinicId);
      await this.updateClinicInfo(this.clinicId, selectedClinic.clinicName);
      this.$toast.success('切换成功');
      this.$emit('refresh');
      this.visible = false;
    },
    async updateClinicInfo(clinicId, clinicName) {
      await Promise.all([
        this.$store.dispatch('set_curClinicId', clinicId),
        this.$store.dispatch('set_curClinicName', clinicName)
      ]);
    },
    async getBindClinics() {
      console.log('----位置无----');
      const res = await services.mall.getChangeClinicList({ lat: this.latitude, lng: this.longitude });
      this.clinicList = res.data;

      const defaultClinic = this.clinicList[0];
      const currentClinicExists = this.clinicList.some(item => item.clinicId === this.curClinicId);

      if (!this.curClinicId || !currentClinicExists) {
        this.clinicId = defaultClinic.clinicId;
        await this.updateClinicInfo(this.clinicId, defaultClinic.clinicName);
      } else {
        this.clinicId = Number(this.curClinicId);
      }

      if (this.immediate) {
        this.$emit('refresh');
      }

      if (this.initShow) {
        this.selectClinic();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .van-radio-group {
    > div {
      border: 1px solid $bordercolor;
      margin: $tb 0;
      padding: $tb $lr;
      border-radius: $radius;
      transition-duration: 0.2s;
      &[aria-checked='true'] {
        border: 1px solid $appcolor;
      }
    }
  }
}

.clinic-info {
  padding: $tb $lr 4px;
  color: $black1;

  @include flex(row);
  align-items: center;
  .avatar {
    width: 22px;
    height: 22px !important;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 8px;
  }
  .name {
    // @include hiddenText();
    // flex: 1;
    line-height: 1.2;
    font-size: $size4;
    font-weight: 600;
  }
}

.opinion-warp {
  padding: $tb $lr;
  width: 300px;

  .opinion-title {
    text-align: center;
    font-size: $size1;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .radio-warp {
    max-height: 50vh;
    overflow-y: auto;
  }
  .btn {
    margin-bottom: 0;
  }
}
</style>
